var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticky top-0 z-40 grid items-center w-full h-16 col-auto pl-12 pr-2 bg-white border-b lg:pl-2"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }